import { ReactNode } from "react";
import { Palette } from "../../../theme";
import { InputValidator, RequiredValidator } from "./validator/Validator";

export enum InputTypes {
  text = "text",
  phone = "tel",
  email = "email",
  password = "password",
  number = "number",
  select = "select",
  date = "date",
}
export enum BorderType {
  complete = "complete",
  bottom = "bottom",
}

export type InputTypeFormatter = (
  value: string,
  previousValue: string
) => string;

export interface InputProps<T> {
  inputLabel?: string;
  borderType?: BorderType;
  type: InputTypes;
  initialValue?: string;
  isCleared?: boolean;
  placeHolder?: string;
  onInputValueChange: (
    value: string,
    key?: keyof T,
    index?: number,
    event?: MouseEvent
  ) => void;
  keyProp?: keyof T;
  autoComplete?: boolean;
  requiredValidator?: RequiredValidator;
  floatingComponent?: React.ReactChild;
  leadingComponent?: ReactNode;
  inputValidator?: InputValidator;
  isRequired?: boolean;
  title?: string;
  onFocus?: () => void;
  onClick?: () => void;
  onBlur?: () => void;
  onclickFloatingComponent?: () => void;
  onLeadingComponentClick?: () => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  afterSubmit?: boolean;
  inputFormatter?: InputTypeFormatter;
  min?: number;
  max?: number;
  step?: number;
  isReadOnly?: boolean;
  isDisabled?: boolean;
  showLoadingState?: boolean;
  isAutoFocus?: boolean;
}

export interface InputLabelProps {
  isRequired?: boolean;
}
export interface InputCssProps {
  theme?: Palette;
}

export interface InputBorderProps {
  hasError?: boolean;
  isRequired?: boolean;
  theme?: Palette;
  borderType?: BorderType;
}

export interface InputLoaderProps {
  isCleared?: boolean;
}
